let replaceSearchParamsQueue = Promise.resolve();

const waitForNavigationTick = () => new Promise((resolve) => {
  window.setTimeout(resolve, 0);
});

export const removeQueryParam = (navigate, queryParam) => {
  replaceSearchParamsQueue = replaceSearchParamsQueue
    .catch(() => {})
    .then(async () => {
      const searchParams = new URLSearchParams(window.location.search);
      if (!searchParams.has(queryParam)) {
        return;
      }

      searchParams.delete(queryParam);

      const nextSearch = searchParams.toString();
      const nextSearchValue = nextSearch ? `?${nextSearch}` : "";

      if (nextSearchValue === window.location.search) {
        return;
      }

      navigate({
        pathname: window.location.pathname,
        search: nextSearchValue,
        hash: window.location.hash,
      }, { replace: true });

      await waitForNavigationTick();
    });

  return replaceSearchParamsQueue;
};
